import CheckMarkIcon from '@/assets/icons/checkMark3DIcon.png';
import CodeIcon from '@/assets/icons/code3DIcon.png';
import GoalIcon from '@/assets/icons/goal3DIcon.png';
import { CommunicationsApi } from '@/services';
import { CustomerSelectors } from '@/store/customer';
import { SnackbarActions } from '@/store/snackbar';
import { Box, Button, Grid2 as Grid, Typography } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Perk } from './Perk';
const PerkList = [
    {
        perkTitle: 'Initial Pipeline',
        img: React.createElement("img", { src: CheckMarkIcon, alt: "check" }),
        perkDescription: 'Kickstart your funding journey with an initial, actionable pipeline of opportunities',
    },
    {
        perkTitle: 'Find More Opportunities',
        img: React.createElement("img", { src: CodeIcon, alt: "code" }),
        perkDescription: 'With 60 days access to our platform, you can add as many more grant opportunities as you’d like!',
    },
    {
        perkTitle: 'Strategy Session',
        img: React.createElement("img", { src: GoalIcon, alt: "goal" }),
        perkDescription: 'Get a 1 hour strategy call with a grant expert to review the funding pipeline and solidify your application strategy.c ',
    },
];
export const PackagePerks = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { email } = useSelector(CustomerSelectors.makeCustomer);
    const handleOfferReject = async () => {
        try {
            await CommunicationsApi.createKickStartFollowUp({ email });
            navigate({ pathname: '/emailconfirmation' });
        }
        catch (err) {
            dispatch(SnackbarActions.enqueueSnackbar({
                message: 'There was an error with the request. please reach out to support@catalyzingconcepts.com',
            }));
        }
    };
    return (React.createElement(Box, { sx: {
            px: 4,
            pt: 6,
            pb: 4,
            position: 'relative',
            zIndex: 10,
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'primary.dark',
            flexDirection: 'column',
        } },
        React.createElement(Box, { sx: {
                py: 4,
                px: 5,
                width: '100%',
                maxWidth: '880px',
                borderRadius: '16px',
                backgroundColor: 'success.dark',
            } },
            React.createElement(Typography, { mb: 4, color: "white", fontSize: { xs: '1.5rem', sm: '2rem' }, fontWeight: 600 }, "Package Key Benefits"),
            React.createElement(Grid, { container: true, spacing: 3 }, PerkList.map(({ perkTitle, perkDescription, img }) => (React.createElement(Grid, { key: perkTitle, size: { xs: 12, sm: 4 } },
                React.createElement(Perk, { img: img, perkTitle: perkTitle, perkDescription: perkDescription })))))),
        React.createElement(Button, { variant: "text", onClick: handleOfferReject, sx: { color: '#FFFFFF', textTransform: 'unset' } }, "No thanks, I would rather just see the list of grants")));
};
